<div class="header">{{ '+BOOKING.PLAN.FEATURE.PACKAGE_CONTENT' | translate }}</div>
<div class="plans-wrapper">
  <app-booking-plans-package-content [isVoucherContent]="true"></app-booking-plans-package-content>

  <div class="voucher-row flex flex-row">
    <div class="flex-[100%] max-w-[60%] !hidden gt-md:!block"></div>
    <div
      class="voucher-details flex flex-col justify-start items-center flex-[100%] max-w-[20%] !hidden gt-md:!flex"
    >
      <p class="voucher-info">{{ '+BOOKING.PLAN.BASIC_PACKAGE_DESCRIPTION' | translate }}</p>
    </div>
    <div class="pro-voucher-wrapper">
      <div class="voucher-details flex flex-col justify-start items-center">
        <div class="voucher-details-section flex flex-col justify-start items-center">
          <p class="voucher-info">
            {{ '+BOOKING.PLAN.VOUCHER.INFO_ACTIVATION_CODE' | translate }}
          </p>
          <div class="voucher-wrapper">
            <button
              class="enter-code-button"
              data-at-buy-Pro-button
              mat-raised-button
              color="primary"
              (click)="enterCode()"
              gtm="onSelect"
              gtmAction="Pro voucher"
              gtmCategory="booking"
            >
              {{ '+BOOKING.PLAN.VOUCHER.ENTER_CODE' | translate }}
            </button>
          </div>

          <div class="test-wrapper">
            <p class="test-info">
              {{ '+BOOKING.PLAN.VOUCHER.THREE_MONTHS_TEST' | translate }}
              <mat-icon
                inline="true"
                [matTooltip]="'+BOOKING.VOUCHER.TEST_FOR_FREE_TOOLTIP' | translate"
                >info_outline</mat-icon
              >
            </p>
            <button
              class="test-button"
              data-at-buy-Trial-button
              mat-stroked-button
              gtm="onSelect"
              gtmAction="Test for free Pro voucher"
              gtmCategory="booking"
              (click)="testTrial()"
            >
              {{ '+BOOKING.OVERVIEW.BUTTON.TEST_FOR_FREE' | translate }}
            </button>
            <ng-container *ngIf="bookingStore.trialSubscriptions$ | async as trialSubscriptions">
              <p *ngIf="trialSubscriptions.remaining && trialSubscriptions.total" class="test-info">
                {{ '+BOOKING.DEVICES.REMAINING_DEVICES' | translate }}
                {{ trialSubscriptions.remaining }} /
                {{ trialSubscriptions.total }}
              </p>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="pro-voucher-frame !hidden gt-md:!block"></div>
</div>
